// src/version.ts
var version = "2.22.5";
export {
  version
};
